import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2711">
      <div className="dark" data-id="element-2712">
        <Hero data-id="element-2713" />
      </div>
      <WhyUs data-id="element-2714" />
      <ByTheNumbers data-id="element-2715" />
      <Services data-id="element-2716" />
      <HowItWorks data-id="element-2717" />
      <FAQ data-id="element-2718" />
      <Reviews data-id="element-2719" />
      <CtaBanner data-id="element-2720" />
    </main>;
}